import {
    UserStatusCongratulationsIconBackgroundDesktopStyled,
    UserStatusCongratulationsIconBackgroundMobileStyled,
} from './styled/UserStatusCongratulationsIconBackgroundStyled';
import { TUserStatuses } from '../UserStatuses.t';
import { USER_STATUSES_CONFIG } from '../userStatusesConstants';

interface IUserStatusCongratulationsIconBackgroundProps {
    isDesktop?: boolean,
    statusName: TUserStatuses,
}

function UserStatusCongratulationsIconBackground(props: IUserStatusCongratulationsIconBackgroundProps) {
    const { isDesktop, statusName } = props;
    const { congratulationsIconBackground } = USER_STATUSES_CONFIG[statusName] || {};

    return isDesktop
        ? <UserStatusCongratulationsIconBackgroundDesktopStyled background={congratulationsIconBackground}/>
        : <UserStatusCongratulationsIconBackgroundMobileStyled background={congratulationsIconBackground}/>;
}

export default UserStatusCongratulationsIconBackground;
